module.exports = __webpack_public_path__ + "static/media/LCC-Logo-sa-1200.72016fa5.png";